import React, { Component } from 'react';
import clsx from 'clsx';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { CssBaseline, CircularProgress, Container } from '@mui/material';
import { withStyles } from '@mui/styles';
import { Styles } from '../../styles/material-styles';
import { Overlay } from '../../styles/global';
import CustomizedSnackbars from '../../components/material-snackbars';
import HeaderMenu from '../../components/header-menu';
import Api from '../../services/api';
import { AbilityContext } from '../../config/ability-context'
import * as componentActions from '../../redux/actions/automation';
import Footer from '../../components/footer';
import { FormattedMessage, injectIntl } from 'react-intl';
import MainAutomationTemplateList from './automation-template-list';

class AutomationTemplatesList extends Component {

    constructor(props) {
        super(props);

        this.typingTimeout = null;
        const { userSession } = this.props;
        this.state = {
            loading: false,
            openNotification: false,
            notificationVariant: 'error',
            notificationMessage: '',
            resultList: [],

            page: 1,

            searchValue: ''
        };

        this.callSearch = this.callSearch.bind(this);
        this.onFieldChange = this.onFieldChange.bind(this);
        this.closeNotification = this.closeNotification.bind(this);
        this.clearFields = this.clearFields.bind(this);
    }

    onFieldChange(event) {
        this.setState({ [event.target.name]: event.target.value, page: 1 });
    }

    callSearch() {
        if (this.state.searchValue != '') {
            this.getItens(this.state.page);
        }
    }

    async clearFields() {
        await this.setState({ searchValue: '', page: 1 })
        this.getItens(1);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.location.state === "reload") {
            this.componentDidMount();
        }
    }

    componentDidMount() {
        this.getItens(1);
    }

    getItens(page = 1) {

        this.setState({ loading: true });
        let url = `/automation/templates`;

        Api.get(url)

            .then(result => {
                if (result.data.success) {
                    const formattedList = new Array();

                    
                    const sorted = result.data.data
                        .sort((a, b) => a.id - b.id)         
                        .map((item, index) => ({          
                            ...item,
                            index: index + 1
                        }));

                    formattedList[0] = sorted;
                    formattedList[1] = sorted.filter(item => item.automationtypeid == 1);
                    formattedList[2] = sorted.filter(item => item.automationtypeid == 2);
                    formattedList[3] = sorted.filter(item => item.automationtypeid == 3);
                    this.setState({ loading: false, resultList: formattedList });
                }
                else {
                    const intl = this.props.intl;
                    this.setState({
                        loading: false, openNotification: true, notificationVariant: "error",
                        notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                    });
                    Api.kickoff(result);
                }
            })
            .catch(err => {
                const intl = this.props.intl;
                this.setState({
                    loading: false, openNotification: true, notificationVariant: "error",
                    notificationMessage: err.response && err.response.data && err.response.data.errors && err.response.data.errors[0] ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                });
                Api.kickoff(err);
            });
    };

    getItemForUpdateAsync = async (id, isSetLoading = false) => {

        if (isSetLoading) {
            this.setState({ loading: true });
        }

        let resultData = null;

        let url = `/automation/${id}`;
        await Api.get(url)
            .then(result => {
                if (result.data) {
                    resultData = result.data.data;
                    this.setState({ loading: false });
                }
                else {
                    const intl = this.props.intl;
                    this.setState({
                        loading: false, openNotification: true, notificationVariant: "error",
                        notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                    });
                    Api.kickoff(result);
                }
            })
            .catch(err => {
                const intl = this.props.intl;
                this.setState({
                    loading: false, openNotification: true, notificationVariant: "error",
                    notificationMessage: err.response && err.response.data && err.response.data.errors && err.response.data.errors[0] ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                });
                Api.kickoff(err);
            });

        return resultData;
    };

    handleGoToEditAutomationTemplate = (data) => {
        this.setState({ loading: true });

        this.props.addCurrent(data);
        this.props.history.push(`/${this.props.match.params.lang}/automation-edit`);

        this.setState({ loading: false });
    }

    closeNotification() {
        this.setState({ openNotification: false });
    }

    render() {
        const { classes, headerMenu, actionsHeaderMenu } = this.props;
        const intl = this.props.intl;

        if (Api == null) {
            var l = this.props.match.params.lang;
            document.location.href = `/${l}/unavailable`
        }

        return (
            <div className={classes.root} style={{ paddingLeft: 0, marginLeft: 0 }}>
                <HeaderMenu />
                <main
                    className={clsx(classes.content, {
                        [classes.contentShift]: headerMenu.open,
                    }, classes.actionsContent, {
                        [classes.actionscontentShift]: actionsHeaderMenu.open,
                    })}
                >
                    <div className={classes.drawerHeader} />

                    <Container component='main' maxWidth='xl' style={{ maxWidth: '100%', paddingLeft: 0, marginLeft: 0 }} data-tour="automation-templates-list">
                        <CssBaseline />
                        <MainAutomationTemplateList
                            columns={[
                                { title: intl.formatMessage({ id: "id" }), field: 'id' },
                                { title: intl.formatMessage({ id: "name" }), field: 'name' },
                                { title: intl.formatMessage({ id: "url" }), field: 'url' },
                                { title: intl.formatMessage({ id: "access.token.field.name" }), field: 'accesstokenfieldname' },
                            ]}
                            data={this.state.resultList}
                            deleteItem={this.deleteItem}
                            match={this.props.match}
                            getItemForUpdateAsync={this.getItemForUpdateAsync}
                            handleGoToEditAutomationTemplate={this.handleGoToEditAutomationTemplate}
                        />

                        {this.state.loading && (
                            <Overlay>
                                <CircularProgress color='secondary' />
                            </Overlay>
                        )}

                        <CustomizedSnackbars
                            variant={this.state.notificationVariant}
                            message={this.state.notificationMessage}
                            isOpen={this.state.openNotification}
                            toClose={this.closeNotification}
                        />
                    </Container>
                </main>
                <Footer />
            </div>
        );
    }
}

AutomationTemplatesList.propTypes = {
    classes: PropTypes.object.isRequired
};
const mapStateToProps = state => ({
    actionsHeaderMenu: state.actionsHeaderMenu,
    headerMenu: state.headerMenu,
    userSession: state.userSession,
});
const mapDispatchToProps = dispatch =>
    bindActionCreators(componentActions, dispatch);
export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(AutomationTemplatesList)));

AutomationTemplatesList.contextType = AbilityContext;